const SOURCE_OPTIONS = [
   {
      value: -1,
      label: 'All Sources',
      id: -1,
      name: 'All Sources',
   },
   {
      value: 8,
      label: 'SYND_XML',
      id: 8,
      name: 'SYND_XML',
   }, {
      value: 0,
      label: 'RESULTS_STD',
      id: 0,
      name: 'RESULTS_STD',
   }, {
      value: 3,
      label: 'SMS_ALERT',
      id: 3,
      name: 'SMS_ALERT',
   }, {
      value: 2,
      label: 'EMAIL_JOB',
      id: 2,
      name: 'EMAIL_JOB',
   }, {
      value: 1,
      label: 'RESULTS_EMAIL',
      id: 1,
      name: 'RESULTS_EMAIL',
   }, {
      value: 9,
      label: 'APP',
      id: 9,
      name: 'APP',
   }, {
      value: 10,
      label: 'APP_NOTIFICATION',
      id: 10,
      name: 'APP_NOTIFICATION',
   }, {
      value: 50,
      label: 'BROWSER_AUDIENCE',
      id: 50,
      name: 'BROWSER_AUDIENCE',
   }, {
      value: 15,
      label: 'BROWSER_NOTIFICATION',
      id: 15,
      name: 'BROWSER_NOTIFICATION',
   }, {
      value: 16,
      label: 'BROWSER_NOTIFICATION_GEN',
      id: 16,
      name: 'BROWSER_NOTIFICATION_GEN',
   }, {
      value: 13,
      label: 'CALL_CENTER',
      id: 13,
      name: 'CALL_CENTER',
   }, {
      value: 45,
      label: 'CL_JOB',
      id: 45,
      name: 'CL_JOB',
   }, {
      value: 20,
      label: 'COREG',
      id: 20,
      name: 'COREG',
   }, {
      value: 24,
      label: 'COREG_AFLAC',
      id: 24,
      name: 'COREG_AFLAC',
   }, {
      value: 26,
      label: 'COREG_AMAZON',
      id: 26,
      name: 'COREG_AMAZON',
   }, {
      value: 31,
      label: 'COREG_CAREGIVER',
      id: 31,
      name: 'COREG_CAREGIVER',
   }, {
      value: 23,
      label: 'COREG_CONDUENT',
      id: 23,
      name: 'COREG_CONDUENT',
   }, {
      value: 52,
      label: 'COREG_GIG',
      id: 52,
      name: 'COREG_GIG',
   }, {
      value: 22,
      label: 'COREG_LYFT',
      id: 22,
      name: 'COREG_LYFT',
   }, {
      value: 21,
      label: 'COREG_PLATINUM',
      id: 21,
      name: 'COREG_PLATINUM',
   }, {
      value: 33,
      label: 'COREG_RETAIL',
      id: 33,
      name: 'COREG_RETAIL',
   }, {
      value: 32,
      label: 'COREG_SALES',
      id: 32,
      name: 'COREG_SALES',
   }, {
      value: 34,
      label: 'COREG_SHIPT',
      id: 34,
      name: 'COREG_SHIPT',
   }, {
      value: 30,
      label: 'COREG_TRUCKING',
      id: 30,
      name: 'COREG_TRUCKING',
   }, {
      value: 18,
      label: 'COREG',
      id: 18,
      name: 'COREG',
   }, {
      value: 25,
      label: 'COREG_AFLAC',
      id: 25,
      name: 'COREG_AFLAC',
   }, {
      value: 51,
      label: 'COREG_AMAZON',
      id: 51,
      name: 'COREG_AMAZON',
   }, {
      value: 12,
      label: 'COREG_CAREGIVER',
      id: 12,
      name: 'COREG_CAREGIVER',
   }, {
      value: 36,
      label: 'COREG_CONDUENT',
      id: 36,
      name: 'COREG_CONDUENT',
   }, {
      value: 19,
      label: 'COREG_GIG',
      id: 19,
      name: 'COREG_GIG',
   }, {
      value: 49,
      label: 'INVITE_CANDIDATE',
      id: 49,
      name: 'INVITE_CANDIDATE',
   }, {
      value: 1,
      label: 'RESULTS_EMAIL',
      id: 1,
      name: 'RESULTS_EMAIL',
   }, {
      value: 53,
      label: 'RESULTS_FREE',
      id: 53,
      name: 'RESULTS_FREE',
   }, {
      value: 28,
      label: 'RESULTS_SMS',
      id: 28,
      name: 'RESULTS_SMS',
   }, {
      value: 27,
      label: 'SEO_RESULTS',
      id: 27,
      name: 'SEO_RESULTS',
   }, {
      value: 43,
      label: 'SEO_SEARCH',
      id: 43,
      name: 'SEO_SEARCH',
   }, {
      value: 44,
      label: 'SMS_AUDIENCE',
      id: 44,
      name: 'SMS_AUDIENCE',
   }, {
      value: 11,
      label: 'SMS_JOB_LINK',
      id: 11,
      name: 'SMS_JOB_LINK',
   }, {
      value: 17,
      label: 'SMS_SYNDICATION',
      id: 17,
      name: 'SMS_SYNDICATION',
   }, {
      value: 7,
      label: 'SYND_2CLICK_EMAIL',
      id: 7,
      name: 'SYND_2CLICK_EMAIL',
   }, {
      value: 35,
      label: 'SYND_ADS',
      id: 35,
      name: 'SYND_ADS',
   }, {
      value: 39,
      label: 'SYND_API_BROWSER_NOTIF',
      id: 39,
      name: 'SYND_API_BROWSER_NOTIF',
   }, {
      value: 37,
      label: 'SYN_API_SMS',
      id: 37,
      name: 'SYN_API_SMS',
   }, {
      value: 41,
      label: 'SYN_API_SMS_GENERIC',
      id: 41,
      name: 'SYN_API_SMS_GENERIC',
   }, {
      value: 38,
      label: 'SYND_COREG',
      id: 38,
      name: 'SYND_COREG',
   }, {
      value: 42,
      label: 'SYND_COREG_JOB',
      id: 42,
      name: 'SYND_COREG_JOB',
   }, {
      value: 6,
      label: 'SYND_DIRECT_EMAIL',
      id: 6,
      name: 'SYND_DIRECT_EMAIL',
   }, {
      value: 14,
      label: 'SYND_EMAIL',
      id: 14,
      name: 'SYND_EMAIL',
   }, {
      value: 40,
      label: 'SYND_TRUCKING_COREG',
      id: 40,
      name: 'SYND_TRUCKING_COREG',
   }, {
      value: 5,
      label: 'SYND_WEB',
      id: 5,
      name: 'SYND_WEB',
   }, {
      value: 47,
      label: 'SYND_WEB_HIGH',
      id: 47,
      name: 'SYND_WEB_HIGH',
   }, {
      value: 48,
      label: 'SYND_WEB_LOW',
      id: 48,
      name: 'SYND_WEB_LOW',
   }, {
      value: 46,
      label: 'UPWARD_CORP',
      id: 46,
      name: 'UPWARD_CORP',
   }, {
      value: 4,
      label: 'UPWARD_JOB_APPLICATION_FLOW',
      id: 4,
      name: 'UPWARD_JOB_APPLICATION_FLOW',
   }, {
      value: 29,
      label: 'XML_JOBPAGE',
      id: 29,
      name: 'XML_JOBPAGE',
   },
];

export default SOURCE_OPTIONS;
